export function normalizeWorkspaceInput(raw) {
  if (raw == null || typeof raw !== 'string') return '';
  return raw.trim().replace(/\s+/g, ' ');
}

export function compactWorkspaceKey(raw) {
  const s = normalizeWorkspaceInput(raw).toLowerCase();
  return s.replace(/[\s\-_.]+/g, '').replace(/[^a-z0-9]/g, '');
}
